const D = 70, E = 260, I = 260;
export {
  I as INSET_SIDEBAR_WIDTH,
  D as SIDEBAR_WIDTH_COLLAPSED,
  E as SIDEBAR_WIDTH_EXPANDED
};
